export default {
  '405': '密碼不正確',
  '406': '此用戶不存在',
  '407': '參數不匹配',
  '408': '新密碼和確認密碼不匹配',
  '409': '密碼不正確',
  '411': '用戶已存在',
  '412': '密碼長度不是6-16',
  '413': '手機號已註冊',
  '414': '結束時間不能小於開始時間',
  '415': '請選擇開始日期',
  '416': '請選擇結束日期',
  '417': '請選擇交易賬戶',
  '5002': '獲取餘額錯誤',
  '6002': '發送郵件異常',
  '5003': '賬戶異常，請聯繫管理員',
  '5004': '獲取用戶郵箱模板失敗，請聯繫客服',
  '51001': '賬戶信息不存在',
  '51002': '交易賬號不存在',
  '51003': '交易賬號類型不存在',
  '51004': '交易賬號類型錯誤',
  '500': '服務器異常，請聯繫客服',
  '11000': '獲取餘額失敗，請聯繫客服'
}
